import {Injectable} from '@angular/core';
import {
  NavigationDropdown,
  NavigationItem,
  NavigationLink,
  NavigationSubheading
} from '../interfaces/navigation-item.interface';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {NavigationEnd, NavigationStart, Router} from "@angular/router";
import {filter, map} from "rxjs/operators";

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  items: NavigationItem[] = [];
  pageIsList$ = new BehaviorSubject<boolean>(false);
  private _openChangeSubject = new Subject<NavigationDropdown>();
  openChange$ = this._openChangeSubject.asObservable();

  constructor(private router: Router) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      untilDestroyed(this),
    ).subscribe((item: any) => {
      this.pageIsList$.next(item?.urlAfterRedirects?.includes('list'))
    })
  }

  triggerOpenChange(item: NavigationDropdown) {
    this._openChangeSubject.next(item);
  }

  isLink(item: NavigationItem): item is NavigationLink {
    return item.type === 'link';
  }

  isDropdown(item: NavigationItem): item is NavigationDropdown {
    return item.type === 'dropdown';
  }

  isSubheading(item: NavigationItem): item is NavigationSubheading {
    return item.type === 'subheading';
  }
}
